import { appUrl } from 'utils/wrappers';

import ReportsBase from 'app/collections/reports_base';
import FulfillmentInventoryReport from 'app/models/fulfillment_inventory_report';

export default ReportsBase.extend({
  model: FulfillmentInventoryReport,
  url: appUrl('reports/fulfillment_inventory'),
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_inventory_reports.js